'use strict';

/**
 * Directive: loading
 *
 * @version
 * 13.0.0 MLIBJS-153 Upgrade to font-awesome v6
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdLoader for ES6 usage
 * 12.0.2 #729 MLIBJS-102 Add old loading directive to fix breaking changes
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2023 Build Centrix
 */
var wdLoader = angular.module('wd.loading', [])
    .directive(
        'wdLoader',
        function ()
        {
            return {
                restrict: 'E',
                link: function (scope, elm)
                {
                    scope.isLoading = function ()
                    {
                        return scope.loading.forceLoader;
                    };

                    scope.$watch(
                        scope.isLoading, function (v)
                        {
                            if (v) {

                                elm.css('display', 'block');

                            } else {

                                elm.css('display', 'none');

                            }
                        }
                    );
                },
                template:   '<div class="ajax-loader-container">'+
                    '<div class="ajax-loader">' +
                    '<i class="fa fa-solid fa-gear fa-spin fa-2x"></i>' +
                    '<img ng-src="./images/header-logo.png" class="img-responsive loading-img" title="Webduct Systems Inc." alt="Webduct Systems Inc.">' +
                    '<span>{{loading.loadingText}}</span>' +
                    '</div>' +
                    '</div>'
            };
        });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdLoader;
}